<template>
  <div class="color-selection">
    <p class="h3 mb-2 pt-2 pb-4">Sélectionnez la finition adaptée à votre intérieur</p>

    <div class="row two-parts">
      <div class="col-lg-7">
        <ul class="list-unstyled">
          <li>
            <img class="w-100" :src="require('@/assets/img/radiateurs/'+the_image(state.selected_config.radiatorsFetched[0]))">
          </li>
        </ul>
      </div>
      <div class="col-lg-5 pl-md-4 pr-md-0">

      	<div class="form-check check-base mb-4 pl-0" @click="setDataRad('finition','Brillant')">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios1" value="option1" :checked="state.radiator.finition=='Brillant'">
          <label class="form-check-label" for="exampleRadios1">
          		<div class="radio-check"><i class="far fa-check"></i></div>
          		<div>
          			<p class="mb-0 lead pt-1">Brillant</p>
          			<!-- <span class="text-secondary">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span> -->
          		</div>
          </label>
        </div>
        <div class="form-check check-base mb-4 pl-0" @click="setDataRad('finition','Soft touch dépoli')">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2" :checked="state.radiator.finition=='Soft touch dépoli'">
          <label class="form-check-label" for="exampleRadios2">
          		<div class="radio-check"><i class="far fa-check"></i></div>
             	<div>
          			<p class="mb-0 lead pt-1">Soft touch dépoli</p>
          			<!-- <span class="text-secondary">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span> -->
          		</div>
          </label>
        </div>

        <!-- <div class="bg-light text-secondary py-2 px-3 mb-4">
          <i class="fal fa-info-circle"></i> Lorem ipsum dolor sit amet
        </div> -->

        <router-link :to="{name:routerTo}" class="btn btn-md btn-primary rounded-pill mt-4">
          Étape suivante
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinitionSelection",
  computed:{
    routerTo(){
      if (this.state.radiator.orientation=='vertical'&&(this.state.room_type=='salle-de-bain'||this.state.room_type=='cuisine')){
        return 'TowelSelection'
      }
      else return 'PilotingSelection'
    }
  },
}
</script>

<style scoped>

</style>